import { render, staticRenderFns } from "./ModalEmpresa.vue?vue&type=template&id=604f5cd8&"
import script from "./ModalEmpresa.vue?vue&type=script&lang=js&"
export * from "./ModalEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports